/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import cookies from '~/services/cookies';
import logger from '~/services/logger';
import ErrorScene from '../../scenes/Error';
import WrapWithProviders from '../ssrWrapper';

const ErrorPage = ({ i18n }) => {
	useEffect(() => {
		try {
			const newLocale = cookies.get('language');
			if (newLocale !== i18n.options.lng) {
				i18n.changeLanguage(newLocale);
			}
		} catch (e) {
			logger.error('Changing SSR 500 language failed', e);
		}
	}, [i18n]);

	return (
		<WrapWithProviders i18n={i18n} featureFlags={{}}>
			<ErrorScene />
		</WrapWithProviders>
	);
};

export default ErrorPage;
